export const webType = 2;   // 1美育 2课本里的奥秘

// export const ip = "https://meiyu.jyfs.vip/api";  // 美育服务器
export const ip = "https://kbam.meiyu.video/api";  // 课本里的奥秘课程服务器



// 切换项目时还需修改
// vue.config         ip需要修改
// main.vue中         课本奥秘menu需要隐藏 “用户管理”、“内容配置”、“收到反馈”、“班级”
// teach.vue中        课本奥秘需要隐藏老师的“提问管理”、“期末评价”
// teachAdmin.vue中   课本奥秘需要隐藏学校的“提问管理”、“期末评价”